import React from "react";
import { Container } from "@mui/material";
import PostManagementTable from "../PostManagementTable";

export default function IADraftsSection() {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <PostManagementTable 
        title="Borradores Generados por IA" 
        defaultStatus="draft" 
        defaultIsAutoGenerated={true}
      />
    </Container>
  );
}
